<app-user-header></app-user-header>
<main role="main" class="maincnt mainmrg">
  <div class="getbannersect pb-2">
    <div class="sectpad container-fluid">
      <div class="col-12 text-center webview">
        <img src="assets/images/logo-signup.png" class="signimg" width="100" />
      </div>
      <div class="text-center">
        <a
          href="javascript:void(0)"
          class="backbtn webview arrowlft"
          (click)="back()"
        ></a>
        <h2 class="usersethead semi-bold">Hello, {{ name }}</h2>
        <h6 class="usersetsubhead font-weight-normal-calibre text-muted">
          Honest Gorilla member since
          {{ userObj.createdDate | date: 'MMMM yyyy' }}
        </h6>
        <hr class="hrbdr" />
      </div>

      <div class="sectpad container-fluid graybackgroundclr p-0 pt-4 pb-1">
        <div class="col-sm-6 m-auto p-0 mbwidth">
        <div class="col-12 d-flex p-0">
          <div class="col-6 p-0 pb-4">
          <h5 class="fwgtfive planhead mt-4 w-100">Plan History</h5>
          </div>
          <div
          class="col-6 text-right mt-2 pr-0"
          style=""
        >
          <a
            class="pikclr planseladd"
            href="javascript:void(0)"
            data-toggle="modal"
            data-target="#addressModal"
            (click)="showAddressModal()"
            >Select Address</a
          >
        </div>
          <!-- <div  class="col-6 text-right mt-2 pr-0">
          <h6
            class="usersetsubhead font-weight-normal-calibre text-muted"
            style="text-align: center"
          >
            {{ chanedAddress }}
          </h6>
        </div> -->
      </div>
   
       
      
      <div 
      *ngFor="let singleObj of energyPlanObj; let i = index"
      id="i+1"
      style="margin: 14px 0px 14px 0px"
      >
      <div
        class="plansummary webview othershadw"
     
      
      >
        <div class="d-flex bdrbot align-items-center no-gutters">
          <div class="col-3 text-center img-responsive pt-4">
            <img
              src="{{ singleObj.selectedProduct.energy_provider_image }}"
              alt="{{ selectedProductLogo(singleObj) }}"
              title="{{ selectedProductLogo(singleObj) }}"
            />
            <p class="m-1 font15 font-weight-normal-calibre" id="puctid">
              PUCT #{{ singleObj.selectedProduct.puct }}
            </p>
            <div
              style="padding-top: 30px"
              class="pointer"
              (click)="showSingleObjFilterCard()"
            >
              See Plan Details
              <mat-icon
                style="position: absolute"
                class="pointer"
                (click)="showSingleObjFilterCard()"
                >keyboard_arrow_down</mat-icon
              >
            </div>
          </div>
          <div class="col-9">
            <table class="plansection">
              <colgroup>
                <col width="40%" />
                <col width="20%" />
                <col width="20%" />
                <col width="20%" />
              </colgroup>
              <tbody>
                <tr>
                  <td class="wd50 pl-2">
                    <div
                      style="font-size: 20px; font-family: 'Calibre-Bold'"
                    >
                      Term:
                      {{ singleObj.selectedProduct.terms }} Months |
                      {{ singleObj.selectedProduct.ProductType }}
                    </div>
                    <p>
                      {{ singleObj.selectedProduct.Renewable }}% Renewable
                    </p>
                  </td>
                  <td class="wd50 pl-2">
                    <div
                      style="font-size: 34px; font-family: 'Calibre-Bold'"
                    >
                      ${{
                        math.round(
                          singleObj.selectedProduct.new_tier
                            .ave_monthly_bill
                        )
                      }}
                    </div>
                    <p style="margin-top: 5px">Monthly bill estimate</p>
                    <p>
                      for
                      {{
                        math.round(
                          singleObj.selectedProduct.new_tier
                            .ave_monthly_usage
                        )
                      }}
                      kWh avg usage*
                    </p>
                  </td>
                  <td class="wd50 pl-2">
                    <div
                      style="font-size: 34px; font-family: 'Calibre-Bold'"
                    >
                      {{
                        (
                          singleObj.selectedProduct.new_tier
                            .ave_price_per_KWH * 100
                        ).toFixed(1) + '¢'
                      }}
                    </div>
                    <p style="margin-top: 5px">
                      Avg Price per
                      {{ singleObj.selectedProduct.energy_units }}*
                    </p>
                    <p>
                      (${{
                        math.round(
                          singleObj.selectedProduct.new_tier
                            .ave_monthly_bill
                        )
                      }}
                      <span>&#247;</span
                      >{{
                        math.round(
                          singleObj.selectedProduct.new_tier
                            .ave_monthly_usage
                        )
                      }}kWh)
                    </p>
                  </td>
                  <td class="wd50 wrdbrk pl-2">
                    <p
                      class="fwgtsix"
                      style="
                        font-size: 40px;
                        font-family: 'Calibre-Bold';
                        color: deeppink;
                        line-height: 29px;
                      "
                    >
                      {{
                        (
                          singleObj.selectedProduct.new_tier
                            .ave_price_per_KWH * 100
                        ).toFixed(1) + '¢'
                      }}
                    </p>
                    <p class="font-weight-normal-calibre wrdbrk">
                      per Kwh
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="plan webview align-items-center pt-2 pb-1">
              <div class="plandesc col">
                <span style="font-size: 20px; font-weight: 600">{{
                  singleObj.selectedProduct.product_key
                }}</span>
                <p
                  class="font-weight-normal-calibre text-left"
                  [innerHTML]="singleObj.selectedProduct.description"
                ></p>
              </div>
              <div class="col col-auto webview text-center">
                <!-- <a
                  class="
                    btn
                    signup
                    font18
                    font-weight-bold-calibre
                    sectbtnhvr
                  "
                  (click)="orderProduct(singleObj)"
                  >SIGN ME UP</a
                ><br /> -->
              </div>
            </div>
          </div>
        </div>
        <div class="webview" *ngIf="showSingleObjDetails">
          <div
            style="
              background: #e2e2e2;
              font-family: 'Calibre-SemiBold';
              font-size: 15px;
              margin-top: 10px;
            "
          >
            Plan Details
          </div>
          <div class="d-flex">
            <div class="col-3" style="max-width: 10% !important">
              <div class="d-flex">
                <div class="">
                  <img src="assets/images/pdf.svg" width="18" />
                </div>
                <div>
                  <a
                    class="pikclr pt-1 pl-1"
                    href="{{ singleObj.selectedProduct.productEFL }}"
                    target="_blank"
                    >EFL</a
                  >
                </div>
              </div>
              <div class="d-flex">
                <div class="float-left">
                  <img src="assets/images/pdf.svg" width="18" />
                </div>
                <div>
                  <a
                    class="pikclr pt-1 pl-1"
                    href="{{ singleObj.productTOS }}"
                    target="_blank"
                    >TOS</a
                  >
                </div>
              </div>
              <div class="d-flex">
                <div class="float-left">
                  <img src="assets/images/pdf.svg" width="18" />
                </div>
                <div>
                  <a
                    class="pikclr pt-1 pl-1"
                    href="{{ singleObj.productYRAC }}"
                    target="_blank"
                    >YRAC</a
                  >
                </div>
              </div>
            </div>
            <div class="col-9">
              <div class="">
                <span
                  style="font-size: 14px; font-family: 'Calibre-SemiBold'"
                  >Early Cancellation Fee</span
                ><br />
                <span>
                  ${{ singleObj.selectedProduct.cancellation_fee }} per
                  month remaining on contract. Note: this fee will not
                  apply if you move and provide a forwarding address
                  verifying the move.
                </span>
              </div>
              <div class="">
                <span
                  style="font-size: 14px; font-family: 'Calibre-SemiBold'"
                  >Pricing Details</span
                >
                <div>
                  <table class="plantbl text-center">
                    <thead>
                      <th class="fwgtthree" width="28%">Monthly Usage</th>
                      <th
                        *ngFor="
                          let usageObj of singleObj.selectedProduct.tier
                        "
                        class="
                          tabpad
                          brdrgtblk
                          font-weight-normal-calibre
                          fwgtthree
                        "
                      >
                        {{ math.round(usageObj.usage) }} kWh
                      </th>
                      <th
                        class="radius2 last-th font-weight-bold-calibre"
                      >
                        <span class=""></span
                        >{{
                          math.round(singleObj.selectedProduct.new_tier
                            .ave_monthly_usage)
                        }}
                        kWh
                      </th>
                    </thead>
                    <tbody>
                      <td
                        class="tabpadd radius4 brdrgtblk semi-bold"
                        style="background-color: #e2e2e2 !important"
                      >
                        Average Price per kWh
                      </td>
                      <td
                        *ngFor="
                          let usageObj of singleObj.selectedProduct.tier
                        "
                        class="tabpadd brdrgtblk semi-bold"
                      >
                        {{ (usageObj.avg_charge * 100).toFixed(1)
                        }}<span>&#162;</span>
                      </td>
                      <td
                        class="tabpadd radius3 last-th pdfclr semi-bold"
                      >
                        {{
                          singleObj
                            ? (
                                singleObj.selectedProduct.new_tier
                                  .ave_price_per_KWH * 100
                              ).toFixed(1)
                            : '-'
                        }}¢<font class="fwgtthree">Your Avg&#42;</font>
                      </td>
                    </tbody>
                  </table>
                </div>
                <div>
                  <span style="font-family: 'Calibre-SemiBold'"
                    >Here’s how the charges are calculated:</span
                  >
                  <p>
                    Energy Charge:
                    {{ singleObj.selectedProduct.energy_charge }} cents
                    per kWh (1 - 2000 kWh)
                  </p>
                  <p style="line-height: 6px">
                    Base Charge: ${{ singleObj.selectedProduct.base_fee }}
                    per billing cycle
                  </p>
                  <p>
                    TDU Meter Charge/Month: ${{
                      singleObj.selectedProduct
                        .tdu_delivery_charge_per_kwh
                    }}
                  </p>
                  <p style="line-height: 6px">
                    TDU Delivery Charge:
                    {{ singleObj.selectedProduct.tdu_delivery_charge }}
                    cents per kWh
                  </p>
                  <p style="padding-top: 10px">
                    Avg. Price per kWh = ({{
                      singleObj.selectedProduct.energy_provider
                    }}
                    + TDU Charges) / Total Monthly Usage
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      
      </div>
      <div style="background-color: white" class="mobileview">
              
        <div class="col-sm-9 col-md-10 col-lg-10 p-0 ">
          <table class="plansection ">
            <colgroup>
              <col width="40%" />
              <col width="20%" />
              <col width="20%" />
              <col width="20%" />
            </colgroup>
            <tbody style="border:2px solid #ed1976; border-bottom: 0px;">
              <tr>
                <td
                  class="
                    bdrbotgry
                    bdrrgtgry
                    bdrrgtwhite
                    position-relative
                  "
                >
                  <div class="w-50 float-left pr-2 mblogo">
                    <img src="{{ singleObj.selectedProduct.energy_provider_image  }}" />
                    <p
                      class="m-1 font15 font-weight-normal-calibre"
                      id="puctid"
                    >
                      PUCT #{{ singleObj.selectedProduct.puct }}
                    </p>
                  </div>
                  <div class="mob-pl-0 w-50 float-left pl-2">
                    <p class="fwgtsix text-left">Energy Provider</p>
                    <p
                      class="font-weight-normal-calibre wrdbrk text-left"
                    >
                      {{ singleObj.selectedProduct.energy_provider }}
                    </p>
                  </div>
                </td>
                <td class="bdrbotgry pl-2 bdrrgtgry bdrrgtwhite">
                  <p class="fwgtsix text-left">Plan Name</p>
                  <p class="font-weight-normal-calibre wrdbrk text-left">
                    {{ singleObj.selectedProduct.product_key }}
                  </p>
                </td>
                <td class="bdrbotgry bdrrgtgry wd50 pl-2">
                  <p class="fwgtsix text-left">Term</p>
                  <p class="font-weight-normal-calibre wrdbrk text-left">
                    {{ singleObj.selectedProduct.terms }} Months
                    {{ singleObj.selectedProduct.categoryName }}
                  </p>
                </td>
                <td class="bdrbotgry wd50 wrdbrk pl-2">
                  <p class="fwgtsix text-left">Early Cancellation Fee</p>
                  <p
                    class="font-weight-normal-calibre wrdbrk text-left"
                    *ngIf="singleObj.selectedProduct.cancellation_fee && singleObj.selectedProduct.ETFTypeId != 2"
                  >
                    ${{ singleObj.selectedProduct.cancellation_fee }}  <br /><br />
                  </p>
                  <p
                    class="font-weight-normal-calibre wrdbrk text-left"
                    *ngIf="singleObj.selectedProduct.cancellation_fee && singleObj.selectedProduct.ETFTypeId === 2"
                  >
                    ${{ singleObj.selectedProduct.cancellation_fee }} per month remaining  <br /><br />
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
         
       
        </div>
        <div style="border:2px solid #ed1976; border-top: 0px;border-bottom: 0px;" class="plan">
          <div class="col-sm-4 col-md-4 col-lg-4 plandesc pt-2">
            <p class="fwgtsix">Description</p>
            <p
              class="font-weight-normal-calibre"
              [innerHTML]="singleObj.selectedProduct.description"
            ></p>
          </div>
          <div class="col-sm-8 col-md-8 col-lg-8 pt-2">
            <p class="fwgtsix text-left font15 lnhgt15">Pricing Details</p>
            <table class="plantbl text-center">
              
              <thead>
                <th class="fwgtthree" width="28%">Monthly Usage</th>
                <th
                  *ngFor="
                    let usageObj of singleObj.selectedProduct.tier
                  "
                  class="
                    tabpad
                    brdrgtblk
                    font-weight-normal-calibre
                    fwgtthree
                  "
                >
                  {{ math.round(usageObj.usage) }} kWh
                </th>
                <th
                  class="radius2 last-th font-weight-bold-calibre"
                >
                  <span class=""></span
                  >{{
                    math.round(singleObj.selectedProduct.new_tier
                      .ave_monthly_usage)
                  }}
                  kWh
                </th>
              </thead>
              <tbody>
                <td
                  class="tabpadd radius4 brdrgtblk semi-bold"
                  style="background-color: #e2e2e2 !important"
                >
                  Average Price per kWh
                </td>
                <td
                  *ngFor="
                    let usageObj of singleObj.selectedProduct.tier
                  "
                  class="tabpadd brdrgtblk semi-bold"
                >
                  {{ (usageObj.avg_charge * 100).toFixed(1)
                  }}<span>&#162;</span>
                </td>
                <td
                  class="tabpadd radius3 last-th pdfclr semi-bold"
                >
                  {{
                    singleObj
                      ? (
                          singleObj.selectedProduct.new_tier
                            .ave_price_per_KWH * 100
                        ).toFixed(1)
                      : '-'
                  }}¢<font class="fwgtthree">Your Avg&#42;</font>
                </td>
              </tbody>
            </table>
          </div>
        </div>
        <div style="border:2px solid #ed1976; border-top: 0px" class="">
          <div class="d-flex p-3">
            

            <div
              class="col-4 d-flex flex-row pl-0 text-left"
              *ngIf="singleObj.selectedProduct.Renewable"
            >
              <div class="float-left mr-1">
                <img
                  src="assets/images/leaf.png"
                  alt="Green leaf to signify renewable energy percentage for each product"
                  title="Renewable Energy Green Leaf"
                  width="18"
                />
              </div>
              <div>
                <a class="float-left pikclr pt-1 pl-1" target="_blank"
                  >{{ singleObj.selectedProduct.Renewable }}% Renewable Energy</a
                >
              </div>
            </div>

            <div class="col-2 d-flex flex-row pl-0 text-left">
              <div class="float-left mr-1">
                <img src="assets/images/pdf.svg" width="18" />
              </div>
              <div>
                <a
                  class="float-left pikclr pt-1 pl-1"
                  href="{{ singleObj.selectedProduct.productEFL }}"
                  target="_blank"
                  >EFL</a
                >
              </div>
            </div>

            <div
              class="col-4 d-flex flex-row flexauto forallmore text-left"
            >
              <div class="float-left mr-1">
                <img src="assets/images/pdf.svg" width="18" />
              </div>
              <div>
                <a
                  class="float-left pikclr pt-1 pl-1"
                  href="{{ singleObj.selectedProduct.productTOS }}"
                  target="_blank"
                  >TOS</a
                >
              </div>
            </div>
            <div
              class="
                col-4
                d-flex
                flex-row
                flexauto
                forallmore
                pr-0
                text-left
              "
            >
              <div class="float-left mr-1">
                <img src="assets/images/pdf.svg" width="18" />
              </div>
              <div>
                <a
                  class="float-left pikclr pt-1 pl-1"
                  href="{{ singleObj.selectedProduct.productYRAC }}"
                  target="_blank"
                  >YRAC</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <p
      class="
        font-weight-normal-calibre
        font15
        lnhgt15
        
        mt-1
      "
      style="padding-bottom: 5px"
    >
        Service Address:
        {{
          singleObj.billingAddress.userAddress.street_address +
            ' ' +
            (singleObj.billingAddress.apartment
              ? 'APT ' + singleObj.billingAddress.apartment
              : '') +
            ',' +
            ' ' +
            singleObj.billingAddress.userAddress.city +
            ',' +
            ' ' +
            singleObj.billingAddress.userAddress.state +
            ' ' +
            singleObj.billingAddress.userAddress.zipcode
        }}
        | ESIID: {{ singleObj.esiid }}<br />
        Contract Term:
        {{ isDate(singleObj.serviceTypeDetails.switchDate) ? (singleObj.serviceTypeDetails.switchDate | date: 'M/d/yyyy') : (singleObj.createdDate | date: 'M/d/yyyy') }} -
        {{ singleObj.expirationDate | date: 'M/d/yyyy' }}*
      </p>
      </div>
    </div>
  </div>
  </div>
  </div>
</main>
<div
  *ngIf="addressModalVisible"
  class="modal fade"
  id="addressModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body">
        <button
          type="button"
          class="close videoclose"
          data-dismiss="modal"
          aria-label="Close"
        >
          <!-- <span aria-hidden="true">&times;</span> -->
          <div class="float-right mr-1 mt-1">
            <img src="assets/images/editchart-close.svg" width="20" />
          </div>
        </button>
        <div class="mt-4 text-center">
          <h6 class="font22 filtertxt">
            Filter Your Plans by Service Address
          </h6>
        </div>
        <!-- <div class="mt-3 font-weight-normal-calibre" *ngIf="selectedAddressList && selectedAddressList.length !== 0"> -->
        <div
          class="mt-3 font-weight-normal-calibre addresscontentDiv {{ selectedAddressList.length >= 7 ? 'addresscontentScroll' : ''  }}"
          
          *ngIf="selectedAddressList.length > 0"
        >
        <ng-container *ngFor="let address of selectedAddressList">
          <div class="custom-control custom-radio mb-2" style="display: flex;    align-items: center;    gap: 13px;
          line-height: 1;">
            <div><input
              type="radio"
              name="group"
              id="{{address.esiid}}"
              style="cursor: pointer;"
              (change)="getAddress(address.billingAddress.userAddress,address.esiid)"
              [value]="address.billingAddress.userAddress"
            /></div>
            <div style="cursor: pointer;" (click)="SelectAddressfunction(address.esiid)">
            <span>{{
              address.billingAddress.userAddress.street_address +
              ', ' +
              (address.billingAddress.apartment == "" ? "" : address.billingAddress.apartment + ", ")
              +
              address.billingAddress.userAddress.city +
              ', ' +
              address.billingAddress.userAddress.state +
              ', ' +
              address.billingAddress.userAddress.zipcode + ' | '
            }}</span>
            <br/>
          <span>
            {{
            address.esiid}}</span>
          </div>
          </div>
        </ng-container>
        </div>
        <div class="text-right">
          <a
            class="pikclr font18 linhgt19 font-weight-normal-calibre"
            href="javascript:void(0)"
            (click)="submit()"
            >DONE</a
          >
        </div>
      </div>
    </div>
  </div>
</div>
<div class="energybillssect"></div>
<app-useraccount-settings></app-useraccount-settings>
<app-user-footer></app-user-footer>
